import { SET_QUERY } from "../actions/ActionTypes";

export default function QueryReducer(
  state = [],
  action: Record<string, unknown>
): unknown {
  switch (action.type) {
    case SET_QUERY:
      return action.payload;
    default:
      return state;
  }
}
